import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, Form } from '@angular/forms';

import { OwnerService } from '../../../service/owner/owner.service';
import { PickcaseService } from '../../../service/pickcase/pickcase.service';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9218',
  templateUrl: 'wa9218.component.html',
  styleUrls: ['wa9218.component.scss']
})
export class Wa9218Component implements OnInit {
  public componentTitle = 'WA9218:ピック箱マスタ登録';

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // for error message
  public validation = validation;
  // Define each input element (initial value and validation rule)
  public ownerId: FormControl;
  public mapickcaseId: number;
  public pickcaseCd: FormControl;
  public pickcaseTx: FormControl;
  public volumeNr: FormControl;
  public capacityrateNr: FormControl;
  public selectedOwnerId: number ;
  public ownerResult: string;

  public owners: any

  private errorInfo = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  @Input() selectedownerId: null;
  @Input() selectedOwnerTx: any;
  private isDelayHide = true;

  private isSubmitButtonEnabled = false;

  readonly STRINGS_ACTIVE = 'active';
  readonly STRINGS_ERROR = 'error';

  private ownerIdCls = '';
  private pickcaseCdCls = '';
  private pickcaseTxCls = '';
  private volumeNrCls = '';
  private capacityrateNrCls = ''

  private volumeNrStyle = '';
  private capacityrateNrStyle = '';

  constructor(
    private ownerService: OwnerService,
    private pickcaseService: PickcaseService,
    private commonService: CommonService,
  ) {
    this.ownerId = new FormControl('', [
      Validators.required,
    ]),
    this.pickcaseCd = new FormControl('', [
      Validators.pattern(validation.allBlankOnly),
      Validators.pattern(validation.code39),
      Validators.maxLength(validation.pickcaseCd.maxLength)
    ]);
    this.pickcaseTx = new FormControl('', [
      Validators.pattern(validation.allBlankOnly),
      Validators.maxLength(validation.pickcaseTx.maxLength)]);
    this.volumeNr = new FormControl(0, [
      Validators.required,
      Validators.pattern(validation.decimal_3),
      Validators.max(validation.pickcaseVolumeNr.maxNr),
      Validators.min(validation.pickcaseVolumeNr.minNr)]);
    this.capacityrateNr = new FormControl(100, [
      Validators.required,
      Validators.pattern(validation.integer),
      Validators.max(validation.pickcaseCapacityRateNr.maxNr),
      Validators.min(validation.pickcaseCapacityRateNr.minNr)]);


    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event: any) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    // this.working = true;
    this.ownerService
      .get()
      .then(outputJson => {
        try {
          this.selectedOwnerId = JSON.parse(sessionStorage.getItem('ownerResult')).ownerId;
          if (JSON.parse(sessionStorage.getItem('ownerResult')).ownerId !== undefined) {

            this.owners = outputJson.owners.filter((item: { ownerId: any; }, index: any) => {
              if (item.ownerId === JSON.parse(sessionStorage.getItem('ownerResult')).ownerId) return true;
            });
            this.selectedownerId = JSON.parse(sessionStorage.getItem('ownerResult')).ownerId;
            this.ownerId.setValue(JSON.parse(sessionStorage.getItem('ownerResult')).ownerTx);
            this.ownerResult = sessionStorage.getItem('ownerResult');

          } else {
            this.owners = outputJson.owners;
            this.selectedownerId = null;
            this.ownerResult = sessionStorage.getItem('ownerResult');

            this.ownerId.setValue('');

          }
        } catch (error) {
          this.selectedownerId = null;
        }
      })
    }

  onSubmit() {
    this.errorInfo = '';
    if (!this.isSubmitButtonEnabled)
      return;

    let pickcaseCd = this.pickcaseCd.value.trim();
    let pickcaseTx = this.pickcaseTx.value.trim();
    let capacityrateNr = this.capacityrateNr.value / 100;
    
    let errors = false;
    if (this.ownerId.errors !== null) {
      this.ownerId.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.pickcaseCd.errors !== null) {
      this.pickcaseCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.pickcaseTx.errors !== null) {
      this.pickcaseTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.volumeNr.errors !== null) {
      this.volumeNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.capacityrateNr.errors !== null) {
      this.capacityrateNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }

    if (this.working) return;
    this.working = true;

    let ownerIdValue = this.selectedOwnerId ? this.selectedOwnerId : this.ownerId.value;
    
    this.pickcaseService
      .post(
        ownerIdValue,
        pickcaseCd,
        pickcaseTx, 
        this.volumeNr.value,
        capacityrateNr,
        'wa9218')
      .then(outputJson => {
        if (outputJson.count === 1) {
          sessionStorage.setItem('SuccessInfoMessage', '登録が完了しました');
        }
        this.resetStyle();
        this.working = false;
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cancel() {
    this.errorInfo = '';
    if (this.selectedOwnerId != null) {
        this.selectedOwnerId = null;
    }
    this.resetStyle();
    this.closeButtonClick.emit(false);
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
      let selectedOwnerTx: any;
      this.ownerService
        .get()
        .then(outputJson => {
          if (this.selectedownerId) {
            this.owners = outputJson.owners.filter((item: { ownerId: number; ownerTx: any; }, index: any) => {
              if (item.ownerId === this.selectedownerId) {
                this.selectedOwnerId = item.ownerId;
                selectedOwnerTx = item.ownerTx;
                return true;
              }
            });
            this.ownerId.setValue(selectedOwnerTx);
          } else {
            this.owners = outputJson.owners;
            this.ownerId.setValue('');
          }
        })
        .catch(error => {
          this.errorInfo = this.commonService.getErrorMessage(error);
        });
    }
    else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    this.ownerId.setValue('');
    this.pickcaseCd.setValue('');
    this.pickcaseTx.setValue('');
    this.volumeNr.setValue(0);
    this.capacityrateNr.setValue(100);

    // 初期化時に状態を設定
    this.volumeNrCls = this.STRINGS_ACTIVE;
    this.capacityrateNrCls = this.STRINGS_ACTIVE;

    this.isSubmitButtonEnabled = false;
  }

  ngDoCheck() {
    if (!this.isShow)
      return;

    
    this.ownerIdCls = this.ownerId.disabled ? 'disabled' : this.ownerId.value === '' ? '' : this.STRINGS_ACTIVE;
    this.pickcaseCdCls = this.pickcaseCd.value === '' ? '' : (this.pickcaseCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.pickcaseTxCls = this.pickcaseTx.value === '' ? '' : (this.pickcaseTx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);

    this.checkSubmitButtonState();
  }

  checkSubmitButtonState() {
    this.isSubmitButtonEnabled =
    this.ownerIdCls === this.STRINGS_ACTIVE &&
    this.pickcaseCdCls === this.STRINGS_ACTIVE &&
    this.pickcaseTxCls === this.STRINGS_ACTIVE &&
    this.volumeNrCls === this.STRINGS_ACTIVE &&
    this.capacityrateNrCls === this.STRINGS_ACTIVE;
  }

  clrErr() {
    this.errorInfo = '';
  }

  onVolumeNrInput(event: { target: { value: string; }; }) {
    if (event.target.value === '') {
      this.volumeNrCls = '';
      this.volumeNrStyle = '';
      return
    } else if (Number(event.target.value) === 0) {
      this.volumeNrCls = this.STRINGS_ACTIVE;
      this.volumeNrStyle = '';
      return
    } else {
      this.volumeNrCls = (this.volumeNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
      if (this.volumeNrCls === this.STRINGS_ACTIVE) {
        this.volumeNrStyle = this.STRINGS_ACTIVE;
      } else {
        this.volumeNrStyle = this.STRINGS_ERROR;
      }
    }

    this.checkSubmitButtonState();
  }

  onCapacityrateNrInput(event: { target: { value: string; }; }) {
    if (event.target.value === '') {
      this.capacityrateNrCls = '';
      this.capacityrateNrStyle = '';
      return
    } else if (Number(event.target.value) === 100) {
      this.capacityrateNrCls = this.STRINGS_ACTIVE;
      this.capacityrateNrStyle = '';
      return
    } else {
      this.capacityrateNrCls = (this.capacityrateNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
      if (this.capacityrateNrCls === this.STRINGS_ACTIVE) {
        this.capacityrateNrStyle = this.STRINGS_ACTIVE;
      } else {
        this.capacityrateNrStyle = this.STRINGS_ERROR;
      }
    }

    this.checkSubmitButtonState();
  }

  resetStyle() {
    this.volumeNrStyle = '';
    this.capacityrateNrStyle = '';
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9218/wa9218.component.ts